export default __webpack_public_path__ + "static/media/logo_kapzar_vert.365e7b58.svg";